import React, { useState } from 'react';
import { Users, MapPin, Calendar, TrendingUp, UserPlus, ExternalLink, Mail, Phone, Globe } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Avatar } from '../components/ui/Avatar';
export function ChapterPage() {
  const [selectedChapter, setSelectedChapter] = useState<string | null>(null);
  const chapters = [{
    id: 1,
    name: 'Jakarta Tech Community',
    location: 'Jakarta',
    memberCount: 245,
    coordinator: 'Budi Santoso',
    description: 'The largest tech community in Jakarta focusing on web and mobile development',
    status: 'active',
    nextEvent: 'January 15, 2025',
    email: 'jakarta@atios.id',
    phone: '+62812345678',
    website: 'jakarta.atios.id'
  }, {
    id: 2,
    name: 'Bandung Developer Circle',
    location: 'Bandung',
    memberCount: 189,
    coordinator: 'Siti Nurhaliza',
    description: 'Active Bandung developer community organizing workshops and hackathons',
    status: 'active',
    nextEvent: 'January 20, 2025',
    email: 'bandung@atios.id',
    phone: '+62812345679',
    website: 'bandung.atios.id'
  }, {
    id: 3,
    name: 'Surabaya Tech Hub',
    location: 'Surabaya',
    memberCount: 156,
    coordinator: 'Ahmad Wijaya',
    description: 'Surabaya tech hub focusing on AI and data science',
    status: 'active',
    nextEvent: 'January 25, 2025',
    email: 'surabaya@atios.id',
    phone: '+62812345680',
    website: 'surabaya.atios.id'
  }, {
    id: 4,
    name: 'Yogyakarta Creative Tech',
    location: 'Yogyakarta',
    memberCount: 134,
    coordinator: 'Dewi Lestari',
    description: 'Community combining technology with art and creativity',
    status: 'active',
    nextEvent: 'January 28, 2025',
    email: 'yogya@atios.id',
    phone: '+62812345681',
    website: 'yogya.atios.id'
  }, {
    id: 5,
    name: 'Bali Digital Nomads',
    location: 'Bali',
    memberCount: 98,
    coordinator: 'Made Suryawan',
    description: 'Digital nomad and remote worker community in Bali',
    status: 'active',
    nextEvent: 'February 1, 2025',
    email: 'bali@atios.id',
    phone: '+62812345682',
    website: 'bali.atios.id'
  }, {
    id: 6,
    name: 'Medan Tech Innovators',
    location: 'Medan',
    memberCount: 87,
    coordinator: 'Rina Situmorang',
    description: 'Tech innovator community in Medan',
    status: 'growing',
    nextEvent: 'TBA',
    email: 'medan@atios.id',
    phone: '+62812345683',
    website: 'medan.atios.id'
  }];
  const myChapter = chapters[0]; // Current user's chapter
  return <div className="min-h-screen bg-white" data-id="element-1710">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-1711">
        {/* Header */}
        <div data-id="element-1712">
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1713">
            ATIOS Chapters
          </h1>
          <p className="text-neutral-600" data-id="element-1714">
            Join local communities and expand your network
          </p>
        </div>

        {/* My Chapter */}
        <Card className="border-atios-primary/30 bg-gradient-to-r from-atios-light to-white" data-id="element-1715">
          <CardHeader data-id="element-1716">
            <div className="flex items-center justify-between" data-id="element-1717">
              <CardTitle className="text-lg" data-id="element-1718">Your Chapter</CardTitle>
              <Badge variant="success" data-id="element-1719">MEMBER</Badge>
            </div>
          </CardHeader>
          <CardContent data-id="element-1720">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1721">
              <div data-id="element-1722">
                <h3 className="text-xl font-semibold text-neutral-900 mb-2" data-id="element-1723">
                  {myChapter.name}
                </h3>
                <p className="text-neutral-600 text-sm mb-4" data-id="element-1724">
                  {myChapter.description}
                </p>
                <div className="space-y-2 text-sm" data-id="element-1725">
                  <div className="flex items-center gap-2 text-neutral-600" data-id="element-1726">
                    <MapPin className="w-4 h-4 text-atios-primary" data-id="element-1727" />
                    <span data-id="element-1728">{myChapter.location}</span>
                  </div>
                  <div className="flex items-center gap-2 text-neutral-600" data-id="element-1729">
                    <Users className="w-4 h-4 text-atios-primary" data-id="element-1730" />
                    <span data-id="element-1731">{myChapter.memberCount} members</span>
                  </div>
                  <div className="flex items-center gap-2 text-neutral-600" data-id="element-1732">
                    <Calendar className="w-4 h-4 text-atios-primary" data-id="element-1733" />
                    <span data-id="element-1734">Next event: {myChapter.nextEvent}</span>
                  </div>
                </div>
              </div>
              <div className="space-y-4" data-id="element-1735">
                <div data-id="element-1736">
                  <p className="text-xs text-neutral-500 mb-2" data-id="element-1737">Coordinator</p>
                  <div className="flex items-center gap-3" data-id="element-1738">
                    <Avatar className="h-10 w-10" data-id="element-1739">
                      <div className="bg-atios-light text-atios-primary font-semibold flex items-center justify-center h-full" data-id="element-1740">
                        {myChapter.coordinator.split(' ').map(n => n[0]).join('')}
                      </div>
                    </Avatar>
                    <div data-id="element-1741">
                      <p className="font-medium text-neutral-900" data-id="element-1742">
                        {myChapter.coordinator}
                      </p>
                      <p className="text-xs text-neutral-600" data-id="element-1743">
                        Chapter Coordinator
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex gap-2" data-id="element-1744">
                  <Button className="flex-1" size="sm" data-id="element-1745">
                    <Calendar className="w-4 h-4 mr-2" data-id="element-1746" />
                    View Events
                  </Button>
                  <Button variant="secondary" size="sm" data-id="element-1747">
                    <ExternalLink className="w-4 h-4 mr-2" data-id="element-1748" />
                    Visit Website
                  </Button>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* All Chapters */}
        <div data-id="element-1749">
          <h2 className="text-xl font-semibold text-neutral-900 mb-4" data-id="element-1750">
            All Chapters
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1751">
            {chapters.map(chapter => <Card key={chapter.id} data-id="element-1752">
                <CardHeader data-id="element-1753">
                  <div className="flex items-start justify-between mb-2" data-id="element-1754">
                    <div className="h-12 w-12 rounded-lg bg-atios-light flex items-center justify-center" data-id="element-1755">
                      <Users className="h-6 w-6 text-atios-primary" data-id="element-1756" />
                    </div>
                    <Badge variant={chapter.status === 'active' ? 'success' : 'default'} data-id="element-1757">
                      {chapter.status === 'active' ? 'ACTIVE' : 'GROWING'}
                    </Badge>
                  </div>
                  <CardTitle className="text-base text-neutral-900" data-id="element-1758">
                    {chapter.name}
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4" data-id="element-1759">
                  <p className="text-sm text-neutral-600" data-id="element-1760">
                    {chapter.description}
                  </p>

                  <div className="space-y-2 text-sm" data-id="element-1761">
                    <div className="flex items-center gap-2 text-neutral-600" data-id="element-1762">
                      <MapPin className="w-4 h-4 text-atios-primary" data-id="element-1763" />
                      <span data-id="element-1764">{chapter.location}</span>
                    </div>
                    <div className="flex items-center gap-2 text-neutral-600" data-id="element-1765">
                      <Users className="w-4 h-4 text-atios-primary" data-id="element-1766" />
                      <span data-id="element-1767">{chapter.memberCount} members</span>
                    </div>
                    <div className="flex items-center gap-2 text-neutral-600" data-id="element-1768">
                      <TrendingUp className="w-4 h-4 text-atios-primary" data-id="element-1769" />
                      <span data-id="element-1770">Coordinator: {chapter.coordinator}</span>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-neutral-200 space-y-2" data-id="element-1771">
                    <div className="flex items-center gap-2 text-xs text-neutral-500" data-id="element-1772">
                      <Mail className="w-3.5 h-3.5" data-id="element-1773" />
                      <span data-id="element-1774">{chapter.email}</span>
                    </div>
                    <div className="flex items-center gap-2 text-xs text-neutral-500" data-id="element-1775">
                      <Phone className="w-3.5 h-3.5" data-id="element-1776" />
                      <span data-id="element-1777">{chapter.phone}</span>
                    </div>
                    <div className="flex items-center gap-2 text-xs text-neutral-500" data-id="element-1778">
                      <Globe className="w-3.5 h-3.5" data-id="element-1779" />
                      <span data-id="element-1780">{chapter.website}</span>
                    </div>
                  </div>

                  <Button className="w-full" size="sm" variant={chapter.id === myChapter.id ? 'primary' : 'secondary'} disabled={chapter.id === myChapter.id} data-id="element-1781">
                    {chapter.id === myChapter.id ? <>
                        <Users className="w-4 h-4 mr-2" data-id="element-1782" />
                        Your Chapter
                      </> : <>
                        <UserPlus className="w-4 h-4 mr-2" data-id="element-1783" />
                        Join Chapter
                      </>}
                  </Button>
                </CardContent>
              </Card>)}
          </div>
        </div>

        {/* CTA */}
        <Card className="bg-gradient-to-r from-atios-light to-white border-atios-primary/20" data-id="element-1784">
          <CardContent className="p-8" data-id="element-1785">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-1786">
              <div data-id="element-1787">
                <h3 className="text-xl font-semibold text-neutral-900 mb-2" data-id="element-1788">
                  Want to Create a New Chapter?
                </h3>
                <p className="text-neutral-600" data-id="element-1789">
                  Contact us to establish an ATIOS chapter in your city
                </p>
              </div>
              <Button size="lg" className="whitespace-nowrap" data-id="element-1790">
                Contact Us <ExternalLink className="w-4 h-4 ml-2" data-id="element-1791" />
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}